import React from 'react'

function CartItem() {
  return (
    <div>CartItem</div>
  )
}

export default CartItem